import { CalendarioApp } from "../components/CalendarioApp/CalendarioApp";


export function Calendario() {

    return(
        <CalendarioApp />
    )
}